import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import ApproachSection from './components/ApproachSection';
import CtaSection from './components/CtaSection';

export default function Home() {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <ServicesSection />
        <ApproachSection />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}
